import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';

/**
 * We had seen ELO devices (Chrome on Windows) keep the touch keyboard on-
 * screen even when navigating off of the Checkout screen, leaving no input
 * elements with focus.
 * If text inputs blurring do not normally trigger a keyboard dismissal,
 * doing it imperatively with experimental Web APIs hopefully will 🤞.
 * @see https://developer.mozilla.org/en-US/docs/Web/API/VirtualKeyboard
 */
export const useHideVirtualKeyboard = () => {
  useEffect(() => {
    return () => {
      try {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const vk = (navigator as any).virtualKeyboard;
        vk?.hide();
      } catch (e) {
        datadogRum.addError(e);
      }
    };
  }, []);
};
